import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link as RouterLink } from 'react-router-dom';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Button, Typography, Container } from '@material-ui/core';
import { ComponentsLib } from '@payface-frontends-libs/components';
const { Page, Logo } = ComponentsLib.Generics;
const RootStyle = styled(Page)(({ theme }) => ({
    display: 'flex',
    minHeight: '100%',
    alignItems: 'center',
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(10),
}));
const HeaderStyle = styled('header')(({ theme }) => ({
    top: 0,
    left: 0,
    lineHeight: 0,
    width: '100%',
    position: 'absolute',
    padding: theme.spacing(3, 3, 0),
    [theme.breakpoints.up('sm')]: { padding: theme.spacing(5, 5, 0) },
}));
export function Page500() {
    return (_jsxs(RootStyle, Object.assign({ title: "500 Internal Server Error | Minimal-UI" }, { children: [_jsx(HeaderStyle, { children: _jsx(RouterLink, Object.assign({ to: "/" }, { children: _jsx(Logo, {}, void 0) }), void 0) }, void 0), _jsx(Container, { children: _jsxs(Box, Object.assign({ sx: { maxWidth: 480, margin: 'auto', textAlign: 'center' } }, { children: [_jsx(Typography, Object.assign({ variant: "h3", gutterBottom: true }, { children: "500 Internal Server Error" }), void 0), _jsx(Typography, Object.assign({ sx: { color: 'text.secondary' } }, { children: "There was an error, please try again later." }), void 0), _jsx(Box, { component: "img", alt: "500", src: "/static/illustrations/illustration_500.svg", sx: { width: '100%', maxHeight: 240, my: { xs: 5, sm: 10 } } }, void 0), _jsx(Button, Object.assign({ to: "/", size: "large", variant: "contained", component: RouterLink }, { children: "Go to Home" }), void 0)] }), void 0) }, void 0)] }), void 0));
}
//# sourceMappingURL=Page500.js.map